import { useSoyuzData } from '@spotahome/soyuz/client';

import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  FooterSimplified,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner,
  CitiesProvider,
  HeaderContainer
} from '@spotahome/ui-library';
import ZohoChatbot from '@spotahome/ui-library/src/tenant/components/ZohoChatbot/ZohoChatbot';

import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import LandingTestimonialsSection from '@spotahome/landings-common/src/components/LandingTestimonialsSection';
import LandingFaqsSection from '@spotahome/landings-common/src/components/LandingFaqsSection/LandingFaqsSection';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import Hero from './components/Hero';
import GuaranteesCover from './components/GuaranteesCover';
import SellingPoints from './components/SellingPoints';
import SecurityDeposit from './components/SecurityDeposit';
import Social from './components/Social';
import Help from './components/Help/Help';

import { getFaqs, getStructuredFaqs } from './utils/faqs';

const TenantGuaranteesContainer = () => {
  const { [TenantGuaranteesContainer.NAME]: requestedData } = useSoyuzData();
  const { deviceType, deviceViewType, initialCookie, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <CitiesProvider skipAllCities>
            <ToastContainer />
            {!userId && <GoogleOneTap />}
            <AppBanner source="home" deviceType={deviceType} />
            <ZohoChatbot />

            <HeaderContainer />
            <Hero />
            <GuaranteesCover />
            <SecurityDeposit />
            <SellingPoints />
            <LandingTestimonialsSection />
            <LandingFaqsSection faqs={getFaqs()} />
            <Help />
            <Social />
            <FooterSimplified />

            <LazyLoginSignUpModal deviceViewType={deviceViewType} />
          </CitiesProvider>
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

TenantGuaranteesContainer.NAME = 'TenantGuaranteesContainer';

TenantGuaranteesContainer.requestAllData = async req => {
  return {
    headers: {
      scripts: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(getStructuredFaqs(req.trans))
        }
      ]
    },
    data: {
      deviceType: req.device.type,
      deviceViewType: req.device.viewType,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

export default TenantGuaranteesContainer;
